import 'material-symbols'
import 'react-toastify/dist/ReactToastify.css'
import '@/services/sentry'

import { setDefaultOptions } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'

import { GlobalProvider } from '@/providers/global-provider'
import AppRoutes from '@/routes'
import { initHotjar } from '@/services/hotjar'

setDefaultOptions({ locale: ptBR })

function App() {
  useEffect(() => {
    initHotjar()
  }, [])

  return (
    <GlobalProvider>
      <ToastContainer theme='colored' position='bottom-center' icon={false} />
      <AppRoutes />
    </GlobalProvider>
  )
}

export default App
